import React from "react";
import moment from "moment";
import UAParser from "ua-parser-js";
import "moment/locale/sv";
import { GetData } from "./axios";
import { GetAvdelningById } from "./UserFunctions";
import Icon from "../assets/icons/Icon";
import {
  AccountType,
  Actions,
  ListType,
  PermissionTypes,
  SchemaFrekvens,
  UtbetalningKontotyp,
  ViewType,
} from "./Enums";
import Functions from "./Functions";
import _ from "lodash";

// Configuration helpers

export const getCurrentSite = (domain) => {
  //Matchar på kända domännamn
  switch (domain) {
    case "abfgustav.studieforbunden.se":
    case "arretjanst.abf.se":
    case "arretjanst9000.abf.se":
    case "arretjanst.labbc.abf.se":
      return "abf";

    case "bildagustav.studieforbunden.se":
    case "etjanst.bilda.nu":
      return "bilda";

    case "sfrgustav.studieforbunden.se":
    case "etjanst.studieframjandet.se":
    case "test-etjanst.studieframjandet.se":
      return "sfr";

    case "svgustav.studieforbunden.se":
    case "etjanst.sv.se":
    case "etjansttest.sv.se":
      return "sv";

    case "nbvgustav.studieforbunden.se":
    case "etjanst.nbv.se":
      return "nbv";

    case "sensusgustav.studieforbunden.se":
    case "e-tjanst.sensus.se":
      return "sensus";

    case "kulturensgustav.studieforbunden.se":
    case "etjanst.kulturens.net":
      return "kulturens";

    case "folkugustav.studieforbunden.se":
    case "etjanst.folkuniversitetet.se":
    case "gustavetjansttest.rtscloud.se":
      return "folkuniversitetet";

    case "mbsgustav.studieforbunden.se":
    case "etjanst.medborgarskolan.se":
      return "mbs";

    case "ibnrushdgustav.studieforbunden.se":
    case "etjanst.ibnrushd.se":
      return "ibnrushd";

    default: {
      //Generella matchningar på domännamn
      if (domain.includes("abf.se")) return "abf";
      if (domain.includes("bilda.nu")) return "bilda";
      if (domain.includes("studieframjandet.se")) return "sfr";
      if (domain.includes("sv.se")) return "sv";
      if (domain.includes("folkuniversitetet.se")) return "folkuniversitetet";
      if (domain.includes("nbv.se")) return "nbv";
      if (domain.includes("sensus.se")) return "sensus";
      if (domain.includes("medborgarskolan.se")) return "mbs";
      if (domain.includes("kulturens.net")) return "kulturens";
      if (domain.includes("ibnrushd.se")) return "ibnrushd";

      //Defaults to DEV
      return "dev";
    }
  }
};

// Arrangemang helpers

export const IsArbetplanFilled = (arbetsplan) => {
  //Om ingen arbetsplan finns så skippar vi kontrollen
  if (!arbetsplan) return true;
  if (arbetsplan.length === 0) return true;

  let isFilledProperly = true;
  for (let i = 0; i < arbetsplan.length; i++) {
    var aFraga = arbetsplan[i];
    if (aFraga.obligatorisk && !aFraga.svar) {
      isFilledProperly = false; //En obligatorisk fråga har inget svar därav är den icke fylld
      break;
    }
  }
  return isFilledProperly;
};

export function StudieTimmarKlaraAllaSammankomster(schemas) {
  for (let i = 0; i < schemas.length; i++) {
    if (!StudieTimmarKlaraEnSammankomst(schemas[i])) {
      return false;
    }
  }
  return true;
}
export function StudieTimmarKlaraEnSammankomst(sammankomst) {
  return sammankomst?.signeratAntalStudieTimmar > 0;
}

export function NarvaroKlarAllaSammankomster(schemas) {
  for (let i = 0; i < schemas.length; i++) {
    if (!NarvaroKlarEnSammankomst(schemas[i])) {
      return false;
    }
  }
  return true;
}
export function NarvaroKlarEnSammankomst(sammankomst) {
  return sammankomst?.narvaros?.includes(sammankomst?.ledare?.id);
}
export function SammankomstHarPasserat(sammankomst) {
  return sammankomst?.datum < moment().format("YYYY-MM-DD");
}

export function IsSignedVikledare(schemas, uid) {
  const othersSchemas = schemas.find((x) => x.ledare.id !== uid && !x.signerad);
  return othersSchemas ? false : true;
}

export const IsUppfoljningFilled = (uppfoljning) => {
  //Om ingen arbetsplan finns så skippar vi kontrollen
  if (!uppfoljning) return true;
  if (uppfoljning.length === 0) return true;

  let isFilledProperly = true;
  for (let i = 0; i < uppfoljning.length; i++) {
    var aFraga = uppfoljning[i];
    if (aFraga.obligatorisk && !aFraga.svar) {
      isFilledProperly = false; //En obligatorisk fråga har inget svar därav är den icke fylld
      break;
    }
  }
  return isFilledProperly;
};

export const getIcon = (arrVform) => {
  switch (arrVform) {
    case "11":
      return <Icon type="arrCirkel" width="28px" height="22px" />;
    case "12":
      return <Icon type="arrKultur" width="24px" height="24px" />;
    case "13":
      return <Icon type="arrAnnan" width="22px" height="22px" fill="#C6D2E0" />;
    case "21":
      return (
        <div>
          <Icon type="arrCirkel" width="28px" height="22px" />
          <div style={{ marginLeft: "3px" }}>
            <Icon
              type="arrMigration"
              width="22px"
              height="22px"
              fill="#C6D2E0"
            />
          </div>
        </div>
      );
    case "23":
      return (
        <div>
          <Icon type="arrAnnan" width="22px" height="22px" fill="#C6D2E0" />
          <Icon type="arrMigration" width="22px" height="22px" fill="#C6D2E0" />
        </div>
      );
    default:
      return (
        <Icon type="arrUndefined" width="22px" height="22px" fill="#C6D2E0" />
      );
  }
};

export const isInternFieldOnly = (fieldNo) => {
  let internField = [
    12,
    25,
    "amne",
    "publiceringsdatum",
    "avpubliceringsdatum",
  ];
  return internField.includes(fieldNo);
};

export const shouldSkipSchemaStep = (
  arrangemang,
  currentStep,
  stepTypeToCheck
) => {
  const { schemaFrekvens, startdatum, starttid, sluttid } = arrangemang;

  const ledareSkaparEgen =
    schemaFrekvens?.id === SchemaFrekvens.OREGELBUNDET_LEDAREN_SKAPAR;

  const datumIFylld =
    startdatum !== null && starttid !== null && sluttid !== null;

  return (ledareSkaparEgen || !datumIFylld) && currentStep === stepTypeToCheck;
};

// Schema helpers

export const shouldGenereateNewSchemas = (schemas, arrangemang) => {
  const firstSchema = schemas[0];
  const firstSchemaSalID = _.get(firstSchema, "sal.id", null);

  const equalSam = schemas.length === arrangemang.planeratAntalSammankomster;
  const equalStart = firstSchema.datum === arrangemang.startdatum;
  const equalStarttime = firstSchema.starttid === arrangemang.starttid;
  const equalEndtime = firstSchema.sluttid === arrangemang.sluttid;
  const equalSal = firstSchemaSalID === arrangemang.salID;
  return !(
    equalSam &&
    equalStart &&
    equalStarttime &&
    equalEndtime &&
    equalSal
  );
};

export const isBookingOverlapping = (
  dateStart1,
  dateEnd1,
  dateStart2,
  dateEnd2
) => {
  return (
    moment(dateStart1).isBetween(dateStart2, dateEnd2) ||
    moment(dateEnd1).isBetween(dateStart2, dateEnd2) ||
    moment(dateStart1).isSame(dateStart2) ||
    moment(dateStart2).isBetween(dateStart1, dateEnd1)
  );
};

// Permission helpers

export const hasExternPermissions = (avdelningsID) => {
  let skapa = [PermissionTypes.Skapa];
  let skapaAndRegistreraSignera = [
    PermissionTypes.Skapa,
    PermissionTypes.RegistreraSignera,
  ];
  let registereAndSignerea = [PermissionTypes.RegistreraSignera];
  let userPermissions = GetAvdelningById(avdelningsID)?.permissions;
  if (userPermissions) {
    let filteredPermissions = userPermissions?.filter((x) =>
      Object.values(PermissionTypes).includes(x)
    );

    let hasSkapa =
      filteredPermissions.length === skapa.length
        ? !!filteredPermissions.filter((i) => skapa.includes(i)).length
        : false;

    let hasSkapaAndRegistreraSignera =
      filteredPermissions.length === skapaAndRegistreraSignera.length
        ? filteredPermissions.filter((i) =>
            skapaAndRegistreraSignera.includes(i)
          ).length === 2
        : false;

    let hasRegistereAndSignerea =
      filteredPermissions.length === registereAndSignerea.length
        ? !!filteredPermissions.filter((i) => registereAndSignerea.includes(i))
            .length
        : false;
    return hasSkapa || hasSkapaAndRegistreraSignera || hasRegistereAndSignerea;
  } else {
    return false;
  }
};

export const manualPermissionChecker = (
  webbkontoPermissionList,
  allPermissionsAsFlag
) => {
  return webbkontoPermissionList?.find((x) => {
    if (Functions.hasFlag(allPermissionsAsFlag, x)) {
      return true;
    } else {
      return false;
    }
  });
};

// Date helpers

export const getWeekNumber = (date) => moment(date, "YYYY-MM-DD").week();

export const getAge = (persnr) => {
  if (!persnr) {
    return 100;
  }
  if (persnr.length != 12) return 100;
  var year = parseInt(persnr.substring(0, 4));
  var month = parseInt(persnr.substring(4, 6));
  var day = parseInt(persnr.substring(6, 8));
  var date = new Date(year, month, day);
  var ageDifMs = Date.now() - date.getTime();
  var ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const getDate = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const getWeekDay = (startDate) => {
  if (!startDate) {
    return "";
  }
  moment.locale("sv");
  var weekDayName = moment(startDate).format("dddd").slice(0, 3);
  return weekDayName.charAt(0).toUpperCase() + weekDayName.slice(1);
};
export const getWeekDays = (weekDays) => {
  let weekDaysArr = weekDays.split(",").filter(function (e) {
    return e === 0 || e;
  });
  if (weekDaysArr.length > 0)
    return weekDaysArr.map((day, index) => {
      if (index === weekDaysArr.length - 1) {
        return day.slice(0, 2).toUpperCase() + ")";
      } else {
        return day.slice(0, 2).toUpperCase() + " ";
      }
    });
};

export const getMonthAndYear = (date) => {
  moment.locale("sv");
  var monthAndYearName = moment(date).format("MMMM YYYY");
  return monthAndYearName.charAt(0).toUpperCase() + monthAndYearName.slice(1);
};

export const formatDate = (date) => {
  return moment(date).format("YYYY-MM-DD HH:mm");
};

export const formatDateNarvaro = (date) => {
  return moment(date).format("ddd DD MMMM YYYY");
};

//Ons 11/08/21
export const formatDateNarvaro2 = (date) => {
  return moment(date).format("ddd YYYY-MM-DD");
};

//Ons 11 Okt 2021
export const formatDateNarvaro3 = (date) => {
  return moment(date).format("ddd DD MMM YYYY");
};

export const isEditable = (date, time) => {
  if (!date) {
    return false;
  }
  if (!time) {
    time = "00:00";
  }

  let dateString = date + " " + time;
  let reggie = /(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/;
  let dateArray = reggie.exec(dateString);

  let dateObject = new Date(
    +dateArray[1],
    +dateArray[2] - 1, // Careful, month starts at 0!
    +dateArray[3],
    +dateArray[4],
    +dateArray[5]
  );
  return dateObject <= new Date(new Date().getTime() + 30 * 60000);
};

// File helpers

export const print = async (type, id, notSavedId) => {
  const windowReference = window.open();
  let notSaved = notSavedId ? notSavedId : 0;

  const pdf = await GetData(
    "/arrangemangs/" + id + "/print/" + type + "?notSavedId=" + notSaved
  );
  windowReference.location = URL.createObjectURL(
    B64ToBlob(pdf, "application/pdf")
  );
};

export const printUnsaved = async (type, id) => {
  const windowReference = window.open();
  const pdf = await GetData("/arrangemangs/" + id + "/printunsaved/" + type);
  windowReference.location = URL.createObjectURL(
    B64ToBlob(pdf, "application/pdf")
  );
};

export const printDeltagare = async (
  type,
  showAdress,
  sortByLastname,
  showGuardian,
  id
) => {
  const windowReference = window.open();
  const pdf = await GetData(
    "/arrangemangs/" +
      id +
      "/print/" +
      type +
      "?showAdress=" +
      showAdress +
      "&sortByEfternamn=" +
      sortByLastname +
      "&showMalsman=" +
      showGuardian
  );
  windowReference.location = URL.createObjectURL(
    B64ToBlob(pdf, "application/pdf")
  );
};

export const B64ToBlob = (b64Data, contentType) => {
  contentType = contentType || "";
  const sliceSize = 1024;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);

    // if (!contentType) {
    //   let mimeType = await FileType.fromBuffer(byteArray);
    //   console.log("mimeType: ", mimeType);
    //   if (mimeType?.mime) {
    //     contentType = mimeType.mime;
    //   }
    // }
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export function formatBytes(a, b = 2) {
  if (0 === a) return "0 Bytes";
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return (
    parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
    " " +
    ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  );
}

export function fileToByteArray(file) {
  return new Promise((resolve, reject) => {
    try {
      let reader = new FileReader();
      let fileByteArray = [];
      reader.readAsArrayBuffer(file);
      reader.onloadend = (evt) => {
        if (evt.target.readyState == FileReader.DONE) {
          let arrayBuffer = evt.target.result,
            array = new Uint8Array(arrayBuffer);
          for (var byte of array) {
            fileByteArray.push(byte);
          }
        }
        resolve(fileByteArray);
      };
    } catch (e) {
      reject(e);
    }
  });
}

// Permission helpers

export const userHasAccess = (
  type,
  value,
  avdelningId,
  huvudsamverkanspartId
) => {
  let avdelning = GetAvdelningById(avdelningId);
  if (avdelning && value) {
    if (avdelning.samverkansparts) {
      let samverkanspart = avdelning.samverkansparts.find(
        (smp) => smp.id === huvudsamverkanspartId
      );
      if (samverkanspart && samverkanspart[type]) {
        return samverkanspart[type].find((x) => x.id === value.id);
      }
    }
  }
};

export const getUserInfo = (user, smvp) => {
  let userAccount = {
    user: user,
    accountType: AccountType.Arrangemang,
    samverkansparts: [],
    selectedSamverkanspart: smvp || null,
  };

  user?.avdelnings.map((avd) => {
    if (avd.samverkansparts?.length > 0) {
      userAccount.samverkansparts = userAccount.samverkansparts.concat(
        avd.samverkansparts
      );
      userAccount.selectedSamverkanspart = smvp || null;
    }
  });

  if (user.onlySamverkansparts) {
    userAccount.accountType = AccountType.Samverkanspart;
    if (!smvp) {
      let samvId = _.find(userAccount.samverkansparts).id;

      let user = getUserWithSamvFull(userAccount, samvId);
      userAccount.selectedSamverkanspart = user.selectedSamverkanspart;
      let saveData = {
        userID: userAccount.id,
        samvId: samvId,
      };

      localStorage.setItem("selectedSmvp", JSON.stringify(saveData));
      //changeSelectedSmvp(smvpData);
    }
  } else if (smvp) {
    userAccount.accountType = AccountType.Samverkanspart;
  }
  //} else {
  //  smvp;
  //}
  //{
  //  userAccount.accountType = AccountType.Samverkanspart;
  //}

  return userAccount;
};

const getUserWithSamvFull = async (user, samvid) => {
  const smvpData = await GetData(
    "/samverkanspart/" + samvid + "?fullObject=true"
  );

  user.selectedSamverkanspart = smvpData;
  if (smvpData) return user;
};

export const getFirstSamvId = (user) => {
  let samvId = 0;
  let userAccount = {
    samverkansparts: [],
  };
  user?.avdelnings.map((avd) => {
    if (avd.samverkansparts?.length > 0) {
      userAccount.samverkansparts = userAccount.samverkansparts.concat(
        avd.samverkansparts
      );
    }
  });
  if (user.onlySamverkansparts) {
    samvId = _.find(userAccount.samverkansparts)?.id;
  }
  return samvId;
};

// Device info helpers

export const getDeviceInfo = () => {
  var parser = new UAParser();
  const deviceInfo = parser.getResult();
  return (
    "Webbläsare: " +
    deviceInfo.browser.name +
    " Version: " +
    deviceInfo.browser.version +
    ";" +
    "Enhet: " +
    deviceInfo.device.model +
    " " +
    deviceInfo.device.type +
    " " +
    deviceInfo.device.vendor +
    ";" +
    "OperativSystem: " +
    deviceInfo.os.name +
    " Version: " +
    deviceInfo.os.version +
    ";" +
    "Engine: " +
    deviceInfo.engine.name +
    " Version: " +
    deviceInfo.engine.version +
    ";" +
    "UserAgent: " +
    deviceInfo.ua
  );
};

// Other helper

export function mapOrder(a, order, key) {
  const map = order.reduce((r, v, i) => ((r[v] = i), r), {});
  return a.sort((a, b) => map[a[key]] - map[b[key]]);
}

export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const formatOrgNo = (orgNo) => {
  return orgNo ? (orgNo.length == 10 ? orgNo.insert(6, "-") : orgNo) : "";
};

export const formatAddress = (value, skipNullCheck = false) => {
  const {
    isNull = true,
    coAdress = "",
    land = "",
    adress = "",
    ort = "",
    postnr = "",
  } = value;
  if ((!isNull || skipNullCheck) && adress) {
    return (
      (coAdress ? "C/O " + coAdress + ", " : "") +
      (adress ? adress : "") +
      ", " +
      (postnr
        ? postnr.length > 3 && !postnr.includes(" ")
          ? postnr.insert(3, " ")
          : ""
        : "") +
      ", " +
      ort +
      " " +
      (land ? (land === "Sverige" || land === "Sweden" ? "" : land) : "")
    );
  } else return "";
};

export const formatPgBg = (kontoTyp, utbetalningKontonr, clearingNr) => {
  const type = getKeyByValue(UtbetalningKontotyp, kontoTyp);

  switch (kontoTyp) {
    case UtbetalningKontotyp.Bankkonto:
      return type + " " + clearingNr + " - " + utbetalningKontonr;
    case UtbetalningKontotyp.Plusgiro:
      if (utbetalningKontonr?.length < 2) {
        return type + " " + utbetalningKontonr;
      } else {
        return (
          type +
          " " +
          utbetalningKontonr?.substring(0, utbetalningKontonr.length - 1) +
          "-" +
          utbetalningKontonr?.substring(utbetalningKontonr.length - 1)
        );
      }
    case UtbetalningKontotyp.Bankgiro:
      if (utbetalningKontonr?.length < 5) {
        return type + " " + utbetalningKontonr;
      } else {
        return (
          type +
          " " +
          utbetalningKontonr?.substring(0, utbetalningKontonr.length - 4) +
          "-" +
          utbetalningKontonr?.substring(utbetalningKontonr.length - 4)
        );
      }
    default:
      return type + " " + utbetalningKontonr;
  }
};

String.prototype.insert = function (index, string) {
  if (index > 0) {
    return this.substring(0, index) + string + this.substr(index);
  }
  return string + this;
};

export const getLabelFromView = (viewType, listType, separator = "/") => {
  let addon = "";
  if (typeof listType === "number") {
    switch (listType) {
      case ListType.Samverkanspart:
        addon = "Organisation ";
        break;
      case ListType.Avdelning:
        addon = "Avdelning ";
        break;
      default:
        addon = "Mina ";
        break;
    }
    addon += separator + " ";
  }
  switch (viewType) {
    case ViewType.VisaGodkända:
      return addon + "Godkända";
    case ViewType.VisaSlutförda:
      return addon + "Slutförda";
    case ViewType.VisaPågående:
      return addon + "Pågående";
    case ViewType.VisaArkiverade:
      return addon + "Arkiverade";
    case ViewType.Godkända:
      return addon + "Godkända";
    case ViewType.AttSkickaTillStartare:
      return addon + "Att skicka till startare";
    case ViewType.InskickadeSomSkaGodkännas:
      return addon + "Inskickade som ska godkännas";
    case ViewType.NekadeSomSkaKompletteras:
      return addon + "Nekade som ska kompletteras";
    case ViewType.EjInskickade:
      return addon + "Ej inskickade";
    case ViewType.AttGodkänna:
      return addon + "Att godkänna";
    case ViewType.AttStarta:
      return addon + "Att starta";
    case ViewType.AttRegistreraNärvaro:
      return addon + "Registrera närvaro";
    case ViewType.AttKontrollera:
      return addon + "Att kontrollera närvaro";
    case ViewType.AttSlutrapportera:
      return addon + "Att slutrapportera";
    case ViewType.AttSkapa:
      return "Skapa arrangemang";
    case ViewType.RedigeraStartade:
      return addon + "Redigera pågående";
    default:
      return "";
  }
};

// Export helpers

export const capitalizeObjectKeys = (obj) => {
  return _.transform(obj, (result, val, key) => {
    result[key.charAt(0).toUpperCase() + key.slice(1)] = val;
  });
};

export const returnNewObjectOnlyValidKeys = (obj, validKeys) => {
  const newObject = {};
  Object.keys(obj).forEach((key) => {
    if (validKeys.includes(key)) newObject[key] = obj[key];
  });
  return newObject;
};

// function getDate(date) {
//   if (!(date instanceof Date)) date = new Date(date);
//   return new Date(date.getFullYear(), date.getMonth(), date.getDate());
// }
export function sortAndSetAktiv(schemas, selectedId) {
  if (selectedId) {
    // const d = getDate(activeDate);
    schemas.sort((a, b) => {
      const date1 = a.datum + "T" + a.starttid;
      const date2 = b.datum + "T" + b.starttid;
      if (date1 > date2) return 1;
      if (date1 < date2) return -1;
      return 0;
    });
    schemas.forEach((x) => {
      x.aktiv = x.id === selectedId;
    });
  }
}

export function getSignable(a, s, isApFilled, setModalChoice, uid) {
  let messages = [];
  if (!a) return;
  if (!s || s.length === 0) return;
  const isHuvudledare = a.huvudledare.id === uid;
  const my = s.filter((x) => x.ledare.id === uid);
  if (my.length === 0 && !isHuvudledare)
    messages.push("Du är inte ledare för några sammankomster ännu.");
  if (isHuvudledare && !isApFilled) {
    messages.push(
      <>
        <a
          style={{
            cursor: "pointer",
            color: "#ee9412",
            textDecoration: "underline",
          }}
          onClick={() => setModalChoice(Actions.EditArbetsplan)}
        >
          Arbetsplanen
        </a>{" "}
        är ej komplett.
      </>
    );
  }
  if (my.length > 0 && my.every((x) => x.klar && x.signerad))
    messages.push("De sammankomster du är ledare för är signerade.");
  if (my.find((x) => !isEditable(x.datum, x.starttid)))
    messages.push("Det finns sammankomster som inte har inträffat.");
  if (isHuvudledare) {
    const othersSchemas = s.find((x) => x.ledare.id !== uid && !x.signerad);
    if (othersSchemas)
      messages.push("Andra ledare har ej signerat sina sammankomster.");
  }
  if (my.every((x) => x.klar && !x.signerad)) return messages;
  if (!isHuvudledare) if (my.every((x) => x.klar)) return messages;

  messages.push(
    <>
      Du måste redovisa närvaro samt studietimmar på samtliga sammankomster{" "}
      <a
        style={{
          cursor: "pointer",
          fontWeight: "bold",
          color: "#335cda",
          textDecoration: "underline",
        }}
        onClick={() => setModalChoice(Actions.ShowOverview)}
      >
        se översikt
      </a>{" "}
      eller{" "}
      <a
        style={{
          cursor: "pointer",
          fontWeight: "bold",
          color: "#335cda",
          textDecoration: "underline",
        }}
        onClick={() => setModalChoice(Actions.EditSchemas)}
      >
        ta bort
      </a>{" "}
      de som inte varit.
    </>
  );
  return messages;
}

export function getStudieTimmar(start, end) {
  // à 45 min
  if (!start) start = "00:00";
  if (!end) end = "00:00";
  const st = new Date("1985-01-01T" + start);
  const en = new Date("1985-01-01T" + end);
  var diff = Math.abs(en - st);
  var diffInHours = Math.floor(diff / 1000 / 45 / 60);
  return [...Array(diffInHours + 1).keys()];
}

// hasExternPermission function tester
// let filteredPermissions = [
//   //Utan kontrollera steg
//   //Intern kombination
//   [32, 1, 2, 16],
//   [32, 1],
//   [1],
//   [1, 2],
//   [1, 16],
//   [16, 2],
//   [32, 16],
//   [32, 1, 2],
//   //Med kontrollera steg
//   //Intern kombination
//   [32, 1, 8],
//   [32, 1, 8, 2],
//   [32, 16],
//   [1, 8],
//   [2],
//   [1, 2, 8],
//   [1, 8, 16],
//   [1, 8, 16, 2],
//   [2, 16],
//   [16],
//   //Intern plus extern utan kontrollera steg kombinatin
//   [32, 1, 2, 16, 4],
//   [32, 1, 4],
//   [32, 1, 2, 4],
//   [32, 16, 4],
//   [16, 4],
//   [2, 4],
//   [1, 4],
//   [16, 2, 4],
//   [16, 1, 2, 4],
//   [16, 1, 4],
//   //Intern plus extern med kontrollera steg kombinatin
//   [32, 1, 8, 4],
//   [32, 1, 8, 2, 4],
//   [32, 16, 4],
//   [1, 8, 4],
//   [2, 4],
//   [1, 2, 8, 4],
//   [1, 8, 16, 4],
//   [1, 8, 16, 2, 4],
//   [2, 16, 4],
//   [16, 4],
//   //Extern kombination
//   [4],
//   [32],
//   [32, 4],
// ];
// // console.log("unfiltered: ", userPermissions);
// // console.log("filtered: ", filteredPermissions);

// filteredPermissions.map((x) => {
//   let hasSkapa =
//     x.length === skapa.length
//       ? !!x.filter((i) => skapa.includes(i)).length
//       : false;

//   let hasSkapaAndRegistreraSignera =
//     x.length === skapaAndRegistreraSignera.length
//       ? x.filter((i) => skapaAndRegistreraSignera.includes(i)).length === 2
//       : false;

//   let hasRegistereAndSignerea =
//     x.length === registereAndSignerea.length
//       ? !!x.filter((i) => registereAndSignerea.includes(i)).length
//       : false;

//   console.log(
//     "hasExtern: ",
//     hasSkapa || hasSkapaAndRegistreraSignera || hasRegistereAndSignerea,
//     hasSkapa || hasSkapaAndRegistreraSignera || hasRegistereAndSignerea
//       ? " --- " + x
//       : ""
//   );
// });
